/* global require */
import MapsDirectionsRailway from 'material-ui/lib/svg-icons/maps/directions-railway';
import MapsDirectionsSubway from 'material-ui/lib/svg-icons/maps/directions-subway';
import MapsSatellite from 'material-ui/lib/svg-icons/maps/satellite';
import MapsDirectionsCar from 'material-ui/lib/svg-icons/maps/directions-car';
import MapsDirectionsWalk from 'material-ui/lib/svg-icons/maps/directions-walk';
import MapsLayersClear from 'material-ui/lib/svg-icons/maps/layers-clear';
import MapsLocalPharmacy from 'material-ui/lib/svg-icons/maps/local-pharmacy';
import MapsPlace from 'material-ui/lib/svg-icons/maps/place';
import MapsHotel from 'material-ui/lib/svg-icons/maps/hotel';
import MapsDirectionsBike from 'material-ui/lib/svg-icons/maps/directions-bike';
import MapsLocalMall from 'material-ui/lib/svg-icons/maps/local-mall';
import MapsMyLocation from 'material-ui/lib/svg-icons/maps/my-location';
import MapsLocalOffer from 'material-ui/lib/svg-icons/maps/local-offer';
import MapsLocalSee from 'material-ui/lib/svg-icons/maps/local-see';
import MapsLocalCarWash from 'material-ui/lib/svg-icons/maps/local-car-wash';
import MapsLocalPostOffice from 'material-ui/lib/svg-icons/maps/local-post-office';
import MapsDirections from 'material-ui/lib/svg-icons/maps/directions';
import MapsLocalMovies from 'material-ui/lib/svg-icons/maps/local-movies';
import MapsRestaurantMenu from 'material-ui/lib/svg-icons/maps/restaurant-menu';
import MapsDirectionsBoat from 'material-ui/lib/svg-icons/maps/directions-boat';
import MapsLocalCafe from 'material-ui/lib/svg-icons/maps/local-cafe';
import MapsTerrain from 'material-ui/lib/svg-icons/maps/terrain';
import MapsLocalPhone from 'material-ui/lib/svg-icons/maps/local-phone';
import MapsLocalHotel from 'material-ui/lib/svg-icons/maps/local-hotel';
import MapsLocalPlay from 'material-ui/lib/svg-icons/maps/local-play';
import MapsLocalPizza from 'material-ui/lib/svg-icons/maps/local-pizza';
import MapsLocalAirport from 'material-ui/lib/svg-icons/maps/local-airport';
import MapsLocalShipping from 'material-ui/lib/svg-icons/maps/local-shipping';
import MapsLocalParking from 'material-ui/lib/svg-icons/maps/local-parking';
import MapsNavigation from 'material-ui/lib/svg-icons/maps/navigation';
import MapsMap from 'material-ui/lib/svg-icons/maps/map';
import MapsPinDrop from 'material-ui/lib/svg-icons/maps/pin-drop';
import MapsLocalHospital from 'material-ui/lib/svg-icons/maps/local-hospital';
import MapsDirectionsRun from 'material-ui/lib/svg-icons/maps/directions-run';
import MapsTraffic from 'material-ui/lib/svg-icons/maps/traffic';
import MapsLayers from 'material-ui/lib/svg-icons/maps/layers';
import MapsLocalDrink from 'material-ui/lib/svg-icons/maps/local-drink';
import MapsLocalGroceryStore from 'material-ui/lib/svg-icons/maps/local-grocery-store';
import MapsLocalDining from 'material-ui/lib/svg-icons/maps/local-dining';
import MapsLocalTaxi from 'material-ui/lib/svg-icons/maps/local-taxi';
import MapsPersonPin from 'material-ui/lib/svg-icons/maps/person-pin';
import MapsLocalGasStation from 'material-ui/lib/svg-icons/maps/local-gas-station';
import MapsFlight from 'material-ui/lib/svg-icons/maps/flight';
import MapsLocalActivity from 'material-ui/lib/svg-icons/maps/local-activity';
import MapsLocalFlorist from 'material-ui/lib/svg-icons/maps/local-florist';
import MapsLocalBar from 'material-ui/lib/svg-icons/maps/local-bar';
import MapsDirectionsTransit from 'material-ui/lib/svg-icons/maps/directions-transit';
import MapsLocalPrintshop from 'material-ui/lib/svg-icons/maps/local-printshop';
import MapsLocalAtm from 'material-ui/lib/svg-icons/maps/local-atm';
import MapsStoreMallDirectory from 'material-ui/lib/svg-icons/maps/store-mall-directory';
import MapsLocalConvenienceStore from 'material-ui/lib/svg-icons/maps/local-convenience-store';
import MapsRateReview from 'material-ui/lib/svg-icons/maps/rate-review';
import MapsLocalLibrary from 'material-ui/lib/svg-icons/maps/local-library';
import MapsLocalLaundryService from 'material-ui/lib/svg-icons/maps/local-laundry-service';
import MapsBeenhere from 'material-ui/lib/svg-icons/maps/beenhere';
import MapsDirectionsBus from 'material-ui/lib/svg-icons/maps/directions-bus';
import NavigationMoreHoriz from 'material-ui/lib/svg-icons/navigation/more-horiz';
import NavigationFullscreen from 'material-ui/lib/svg-icons/navigation/fullscreen';
import NavigationCheck from 'material-ui/lib/svg-icons/navigation/check';
import NavigationRefresh from 'material-ui/lib/svg-icons/navigation/refresh';
import NavigationArrowDropDownCircle from 'material-ui/lib/svg-icons/navigation/arrow-drop-down-circle';
import NavigationMenu from 'material-ui/lib/svg-icons/navigation/menu';
import NavigationExpandMore from 'material-ui/lib/svg-icons/navigation/expand-more';
import NavigationUnfoldLess from 'material-ui/lib/svg-icons/navigation/unfold-less';
import NavigationArrowForward from 'material-ui/lib/svg-icons/navigation/arrow-forward';
import NavigationFullscreenExit from 'material-ui/lib/svg-icons/navigation/fullscreen-exit';
import NavigationApps from 'material-ui/lib/svg-icons/navigation/apps';
import NavigationArrowBack from 'material-ui/lib/svg-icons/navigation/arrow-back';
import NavigationArrowDropUp from 'material-ui/lib/svg-icons/navigation/arrow-drop-up';
import NavigationClose from 'material-ui/lib/svg-icons/navigation/close';
import NavigationChevronRight from 'material-ui/lib/svg-icons/navigation/chevron-right';
import NavigationExpandLess from 'material-ui/lib/svg-icons/navigation/expand-less';
import NavigationMoreVert from 'material-ui/lib/svg-icons/navigation/more-vert';
import NavigationArrowDropDown from 'material-ui/lib/svg-icons/navigation/arrow-drop-down';
import NavigationChevronLeft from 'material-ui/lib/svg-icons/navigation/chevron-left';
import NavigationUnfoldMore from 'material-ui/lib/svg-icons/navigation/unfold-more';
import NavigationCancel from 'material-ui/lib/svg-icons/navigation/cancel';
import EditorVerticalAlignBottom from 'material-ui/lib/svg-icons/editor/vertical-align-bottom';
import EditorFormatPaint from 'material-ui/lib/svg-icons/editor/format-paint';
import EditorBorderHorizontal from 'material-ui/lib/svg-icons/editor/border-horizontal';
import EditorFormatAlignRight from 'material-ui/lib/svg-icons/editor/format-align-right';
import EditorBorderStyle from 'material-ui/lib/svg-icons/editor/border-style';
import EditorBorderInner from 'material-ui/lib/svg-icons/editor/border-inner';
import EditorFormatTextdirectionLToR from 'material-ui/lib/svg-icons/editor/format-textdirection-l-to-r';
import EditorBorderColor from 'material-ui/lib/svg-icons/editor/border-color';
import EditorFormatAlignCenter from 'material-ui/lib/svg-icons/editor/format-align-center';
import EditorFormatStrikethrough from 'material-ui/lib/svg-icons/editor/format-strikethrough';
import EditorFormatListBulleted from 'material-ui/lib/svg-icons/editor/format-list-bulleted';
import EditorFunctions from 'material-ui/lib/svg-icons/editor/functions';
import EditorFormatColorText from 'material-ui/lib/svg-icons/editor/format-color-text';
import EditorFormatColorFill from 'material-ui/lib/svg-icons/editor/format-color-fill';
import EditorModeEdit from 'material-ui/lib/svg-icons/editor/mode-edit';
import EditorWrapText from 'material-ui/lib/svg-icons/editor/wrap-text';
import EditorMergeType from 'material-ui/lib/svg-icons/editor/merge-type';
import EditorBorderVertical from 'material-ui/lib/svg-icons/editor/border-vertical';
import EditorVerticalAlignCenter from 'material-ui/lib/svg-icons/editor/vertical-align-center';
import EditorBorderLeft from 'material-ui/lib/svg-icons/editor/border-left';
import EditorFormatListNumbered from 'material-ui/lib/svg-icons/editor/format-list-numbered';
import EditorBorderRight from 'material-ui/lib/svg-icons/editor/border-right';
import EditorFormatLineSpacing from 'material-ui/lib/svg-icons/editor/format-line-spacing';
import EditorFormatIndentDecrease from 'material-ui/lib/svg-icons/editor/format-indent-decrease';
import EditorBorderTop from 'material-ui/lib/svg-icons/editor/border-top';
import EditorModeComment from 'material-ui/lib/svg-icons/editor/mode-comment';
import EditorFormatColorReset from 'material-ui/lib/svg-icons/editor/format-color-reset';
import EditorMoneyOff from 'material-ui/lib/svg-icons/editor/money-off';
import EditorSpaceBar from 'material-ui/lib/svg-icons/editor/space-bar';
import EditorInsertEmoticon from 'material-ui/lib/svg-icons/editor/insert-emoticon';
import EditorFormatQuote from 'material-ui/lib/svg-icons/editor/format-quote';
import EditorVerticalAlignTop from 'material-ui/lib/svg-icons/editor/vertical-align-top';
import EditorFormatAlignLeft from 'material-ui/lib/svg-icons/editor/format-align-left';
import EditorAttachMoney from 'material-ui/lib/svg-icons/editor/attach-money';
import EditorBorderBottom from 'material-ui/lib/svg-icons/editor/border-bottom';
import EditorFormatTextdirectionRToL from 'material-ui/lib/svg-icons/editor/format-textdirection-r-to-l';
import EditorFormatClear from 'material-ui/lib/svg-icons/editor/format-clear';
import EditorInsertDriveFile from 'material-ui/lib/svg-icons/editor/insert-drive-file';
import EditorFormatIndentIncrease from 'material-ui/lib/svg-icons/editor/format-indent-increase';
import EditorInsertChart from 'material-ui/lib/svg-icons/editor/insert-chart';
import EditorInsertComment from 'material-ui/lib/svg-icons/editor/insert-comment';
import EditorFormatBold from 'material-ui/lib/svg-icons/editor/format-bold';
import EditorFormatSize from 'material-ui/lib/svg-icons/editor/format-size';
import EditorBorderClear from 'material-ui/lib/svg-icons/editor/border-clear';
import EditorPublish from 'material-ui/lib/svg-icons/editor/publish';
import EditorAttachFile from 'material-ui/lib/svg-icons/editor/attach-file';
import EditorBorderAll from 'material-ui/lib/svg-icons/editor/border-all';
import EditorStrikethroughS from 'material-ui/lib/svg-icons/editor/strikethrough-s';
import EditorFormatUnderlined from 'material-ui/lib/svg-icons/editor/format-underlined';
import EditorInsertInvitation from 'material-ui/lib/svg-icons/editor/insert-invitation';
import EditorInsertLink from 'material-ui/lib/svg-icons/editor/insert-link';
import EditorBorderOuter from 'material-ui/lib/svg-icons/editor/border-outer';
import EditorFormatAlignJustify from 'material-ui/lib/svg-icons/editor/format-align-justify';
import EditorInsertPhoto from 'material-ui/lib/svg-icons/editor/insert-photo';
import EditorFormatItalic from 'material-ui/lib/svg-icons/editor/format-italic';
import NavigationArrowDropRight from 'material-ui/lib/svg-icons/navigation-arrow-drop-right';
import ToggleCheckBox from 'material-ui/lib/svg-icons/toggle/check-box';
import ToggleStar from 'material-ui/lib/svg-icons/toggle/star';
import ToggleCheckBoxOutlineBlank from 'material-ui/lib/svg-icons/toggle/check-box-outline-blank';
import ToggleStarHalf from 'material-ui/lib/svg-icons/toggle/star-half';
import ToggleStarBorder from 'material-ui/lib/svg-icons/toggle/star-border';
import ToggleIndeterminateCheckBox from 'material-ui/lib/svg-icons/toggle/indeterminate-check-box';
import ToggleRadioButtonUnchecked from 'material-ui/lib/svg-icons/toggle/radio-button-unchecked';
import ToggleRadioButtonChecked from 'material-ui/lib/svg-icons/toggle/radio-button-checked';
import FileCloudOff from 'material-ui/lib/svg-icons/file/cloud-off';
import FileCloud from 'material-ui/lib/svg-icons/file/cloud';
import FileCloudDownload from 'material-ui/lib/svg-icons/file/cloud-download';
import FileFolderOpen from 'material-ui/lib/svg-icons/file/folder-open';
import FileFileUpload from 'material-ui/lib/svg-icons/file/file-upload';
import FileCloudUpload from 'material-ui/lib/svg-icons/file/cloud-upload';
import FileFileDownload from 'material-ui/lib/svg-icons/file/file-download';
import FileCloudDone from 'material-ui/lib/svg-icons/file/cloud-done';
import FileAttachment from 'material-ui/lib/svg-icons/file/attachment';
import FileFolderShared from 'material-ui/lib/svg-icons/file/folder-shared';
import FileCloudQueue from 'material-ui/lib/svg-icons/file/cloud-queue';
import FileCloudCircle from 'material-ui/lib/svg-icons/file/cloud-circle';
import FileFolder from 'material-ui/lib/svg-icons/file/folder';
import CommunicationMessage from 'material-ui/lib/svg-icons/communication/message';
import CommunicationSpeakerPhone from 'material-ui/lib/svg-icons/communication/speaker-phone';
import CommunicationForum from 'material-ui/lib/svg-icons/communication/forum';
import CommunicationLocationOn from 'material-ui/lib/svg-icons/communication/location-on';
import CommunicationDialpad from 'material-ui/lib/svg-icons/communication/dialpad';
import CommunicationContacts from 'material-ui/lib/svg-icons/communication/contacts';
import CommunicationLocationOff from 'material-ui/lib/svg-icons/communication/location-off';
import CommunicationChatBubbleOutline from 'material-ui/lib/svg-icons/communication/chat-bubble-outline';
import CommunicationStayCurrentPortrait from 'material-ui/lib/svg-icons/communication/stay-current-portrait';
import CommunicationCallSplit from 'material-ui/lib/svg-icons/communication/call-split';
import CommunicationCallMissed from 'material-ui/lib/svg-icons/communication/call-missed';
import CommunicationChatBubble from 'material-ui/lib/svg-icons/communication/chat-bubble';
import CommunicationPresentToAll from 'material-ui/lib/svg-icons/communication/present-to-all';
import CommunicationStayPrimaryPortrait from 'material-ui/lib/svg-icons/communication/stay-primary-portrait';
import CommunicationCallReceived from 'material-ui/lib/svg-icons/communication/call-received';
import CommunicationStayPrimaryLandscape from 'material-ui/lib/svg-icons/communication/stay-primary-landscape';
import CommunicationPhonelinkErase from 'material-ui/lib/svg-icons/communication/phonelink-erase';
import CommunicationInvertColorsOff from 'material-ui/lib/svg-icons/communication/invert-colors-off';
import CommunicationCallMerge from 'material-ui/lib/svg-icons/communication/call-merge';
import CommunicationPhonelinkLock from 'material-ui/lib/svg-icons/communication/phonelink-lock';
import CommunicationLiveHelp from 'material-ui/lib/svg-icons/communication/live-help';
import CommunicationSwapCalls from 'material-ui/lib/svg-icons/communication/swap-calls';
import CommunicationTactMail from 'material-ui/lib/svg-icons/communication/tact-mail';
import CommunicationContactPhone from 'material-ui/lib/svg-icons/communication/contact-phone';
import CommunicationPortableWifiOff from 'material-ui/lib/svg-icons/communication/portable-wifi-off';
import CommunicationDialerSip from 'material-ui/lib/svg-icons/communication/dialer-sip';
import CommunicationNoSim from 'material-ui/lib/svg-icons/communication/no-sim';
import CommunicationStayCurrentLandscape from 'material-ui/lib/svg-icons/communication/stay-current-landscape';
import CommunicationCall from 'material-ui/lib/svg-icons/communication/call';
import CommunicationVpnKey from 'material-ui/lib/svg-icons/communication/vpn-key';
import CommunicationVoicemail from 'material-ui/lib/svg-icons/communication/voicemail';
import CommunicationPhonelinkRing from 'material-ui/lib/svg-icons/communication/phonelink-ring';
import CommunicationBusiness from 'material-ui/lib/svg-icons/communication/business';
import CommunicationImportExport from 'material-ui/lib/svg-icons/communication/import-export';
import CommunicationClearAll from 'material-ui/lib/svg-icons/communication/clear-all';
import CommunicationEmail from 'material-ui/lib/svg-icons/communication/email';
import CommunicationComment from 'material-ui/lib/svg-icons/communication/comment';
import CommunicationTextsms from 'material-ui/lib/svg-icons/communication/textsms';
import CommunicationPhonelinkSetup from 'material-ui/lib/svg-icons/communication/phonelink-setup';
import CommunicationCallEnd from 'material-ui/lib/svg-icons/communication/call-end';
import CommunicationCallMade from 'material-ui/lib/svg-icons/communication/call-made';
import CommunicationChat from 'material-ui/lib/svg-icons/communication/chat';
import CommunicationPhone from 'material-ui/lib/svg-icons/communication/phone';
import CommunicationRingVolume from 'material-ui/lib/svg-icons/communication/ring-volume';
import ActionSettingsEthernet from 'material-ui/lib/svg-icons/action/settings-ethernet';
import ActionAssignmentReturned from 'material-ui/lib/svg-icons/action/assignment-returned';
import ActionLockOpen from 'material-ui/lib/svg-icons/action/lock-open';
import ActionReportProblem from 'material-ui/lib/svg-icons/action/report-problem';
import ActionList from 'material-ui/lib/svg-icons/action/list';
import ActionSwapVert from 'material-ui/lib/svg-icons/action/swap-vert';
import ActionTab from 'material-ui/lib/svg-icons/action/tab';
import ActionInfoOutline from 'material-ui/lib/svg-icons/action/info-outline';
import ActionTabUnselected from 'material-ui/lib/svg-icons/action/tab-unselected';
import ActionGif from 'material-ui/lib/svg-icons/action/gif';
import ActionPolymer from 'material-ui/lib/svg-icons/action/polymer';
import ActionExplore from 'material-ui/lib/svg-icons/action/explore';
import ActionThumbDown from 'material-ui/lib/svg-icons/action/thumb-down';
import ActionViewHeadline from 'material-ui/lib/svg-icons/action/view-headline';
import ActionPageview from 'material-ui/lib/svg-icons/action/pageview';
import ActionFavoriteBorder from 'material-ui/lib/svg-icons/action/favorite-border';
import ActionPermPhoneMsg from 'material-ui/lib/svg-icons/action/perm-phone-msg';
import ActionSettingsInputAntenna from 'material-ui/lib/svg-icons/action/settings-input-antenna';
import ActionAssignment from 'material-ui/lib/svg-icons/action/assignment';
import ActionGetApp from 'material-ui/lib/svg-icons/action/get-app';
import ActionPermMedia from 'material-ui/lib/svg-icons/action/perm-media';
import ActionFindInPage from 'material-ui/lib/svg-icons/action/find-in-page';
import ActionSettingsBluetooth from 'material-ui/lib/svg-icons/action/settings-bluetooth';
import ActionCreditCard from 'material-ui/lib/svg-icons/action/credit-card';
import ActionViewWeek from 'material-ui/lib/svg-icons/action/view-week';
import ActionTrackChanges from 'material-ui/lib/svg-icons/action/track-changes';
import ActionCardGiftcard from 'material-ui/lib/svg-icons/action/card-giftcard';
import ActionSettingsBackupRestore from 'material-ui/lib/svg-icons/action/settings-backup-restore';
import ActionBugReport from 'material-ui/lib/svg-icons/action/bug-report';
import ActionHighlightOff from 'material-ui/lib/svg-icons/action/highlight-off';
import ActionChangeHistory from 'material-ui/lib/svg-icons/action/change-history';
import ActionViewAgenda from 'material-ui/lib/svg-icons/action/view-agenda';
import ActionDone from 'material-ui/lib/svg-icons/action/done';
import ActionLockOutline from 'material-ui/lib/svg-icons/action/lock-outline';
import ActionHourglassFull from 'material-ui/lib/svg-icons/action/hourglass-full';
import ActionLabel from 'material-ui/lib/svg-icons/action/label';
import ActionBookmark from 'material-ui/lib/svg-icons/action/bookmark';
import ActionSwapVerticalCircle from 'material-ui/lib/svg-icons/action/swap-vertical-circle';
import ActionEject from 'material-ui/lib/svg-icons/action/eject';
import ActionTrendingFlat from 'material-ui/lib/svg-icons/action/trending-flat';
import ActionGroupWork from 'material-ui/lib/svg-icons/action/group-work';
import ActionSettingsInputSvideo from 'material-ui/lib/svg-icons/action/settings-input-svideo';
import ActionPermContactCalendar from 'material-ui/lib/svg-icons/action/perm-contact-calendar';
import ActionFace from 'material-ui/lib/svg-icons/action/face';
import ActionVerifiedUser from 'material-ui/lib/svg-icons/action/verified-user';
import ActionTheaters from 'material-ui/lib/svg-icons/action/theaters';
import ActionBuild from 'material-ui/lib/svg-icons/action/build';
import ActionPermDataSetting from 'material-ui/lib/svg-icons/action/perm-data-setting';
import ActionQuestionAnswer from 'material-ui/lib/svg-icons/action/question-answer';
import ActionFlipToBack from 'material-ui/lib/svg-icons/action/flip-to-back';
import ActionExtension from 'material-ui/lib/svg-icons/action/extension';
import ActionAccessibility from 'material-ui/lib/svg-icons/action/accessibility';
import ActionAlarmOn from 'material-ui/lib/svg-icons/action/alarm-on';
import ActionQueryBuilder from 'material-ui/lib/svg-icons/action/query-builder';
import ActionAddShoppingCart from 'material-ui/lib/svg-icons/action/add-shopping-cart';
import ActionPayment from 'material-ui/lib/svg-icons/action/payment';
import ActionEventSeat from 'material-ui/lib/svg-icons/action/event-seat';
import ActionInput from 'material-ui/lib/svg-icons/action/input';
import ActionMarkunreadMailbox from 'material-ui/lib/svg-icons/action/markunread-mailbox';
import ActionLoyalty from 'material-ui/lib/svg-icons/action/loyalty';
import ActionPrint from 'material-ui/lib/svg-icons/action/print';
import ActionAutorenew from 'material-ui/lib/svg-icons/action/autorenew';
import ActionDelete from 'material-ui/lib/svg-icons/action/delete';
import ActionAlarmAdd from 'material-ui/lib/svg-icons/action/alarm-add';
import ActionAccountBalance from 'material-ui/lib/svg-icons/action/account-balance';
import ActionAndroid from 'material-ui/lib/svg-icons/action/android';
import ActionBookmarkBorder from 'material-ui/lib/svg-icons/action/bookmark-border';
import ActionLaunch from 'material-ui/lib/svg-icons/action/launch';
import ActionSearch from 'material-ui/lib/svg-icons/action/search';
import ActionZoomOut from 'material-ui/lib/svg-icons/action/zoom-out';
import ActionVisibilityOff from 'material-ui/lib/svg-icons/action/visibility-off';
import ActionLock from 'material-ui/lib/svg-icons/action/lock';
import ActionAccountCircle from 'material-ui/lib/svg-icons/action/account-circle';
import ActionAssignmentLate from 'material-ui/lib/svg-icons/action/assignment-late';
import ActionShop from 'material-ui/lib/svg-icons/action/shop';
import ActionToc from 'material-ui/lib/svg-icons/action/toc';
import ActionShoppingCart from 'material-ui/lib/svg-icons/action/shopping-cart';
import ActionCardMembership from 'material-ui/lib/svg-icons/action/card-membership';
import ActionLabelOutline from 'material-ui/lib/svg-icons/action/label-outline';
import ActionSettings from 'material-ui/lib/svg-icons/action/settings';
import ActionSettingsCell from 'material-ui/lib/svg-icons/action/settings-cell';
import ActionOfflinePin from 'material-ui/lib/svg-icons/action/offline-pin';
import ActionViewDay from 'material-ui/lib/svg-icons/action/view-day';
import ActionDashboard from 'material-ui/lib/svg-icons/action/dashboard';
import ActionViewModule from 'material-ui/lib/svg-icons/action/view-module';
import ActionSettingsApplications from 'material-ui/lib/svg-icons/action/settings-applications';
import ActionViewStream from 'material-ui/lib/svg-icons/action/view-stream';
import ActionViewColumn from 'material-ui/lib/svg-icons/action/view-column';
import ActionSettingsInputComposite from 'material-ui/lib/svg-icons/action/settings-input-composite';
import ActionAccountBalanceWallet from 'material-ui/lib/svg-icons/action/account-balance-wallet';
import ActionInfo from 'material-ui/lib/svg-icons/action/info';
import ActionAssignmentTurnedIn from 'material-ui/lib/svg-icons/action/assignment-turned-in';
import ActionSchedule from 'material-ui/lib/svg-icons/action/schedule';
import ActionPermDeviceInformation from 'material-ui/lib/svg-icons/action/perm-device-information';
import ActionViewList from 'material-ui/lib/svg-icons/action/view-list';
import ActionOpenInBrowser from 'material-ui/lib/svg-icons/action/open-in-browser';
import ActionSettingsPhone from 'material-ui/lib/svg-icons/action/settings-phone';
import ActionFeedback from 'material-ui/lib/svg-icons/action/feedback';
import ActionHttps from 'material-ui/lib/svg-icons/action/https';
import ActionAlarmOff from 'material-ui/lib/svg-icons/action/alarm-off';
import ActionCached from 'material-ui/lib/svg-icons/action/cached';
import ActionTrendingUp from 'material-ui/lib/svg-icons/action/trending-up';
import ActionWork from 'material-ui/lib/svg-icons/action/work';
import ActionPermCameraMic from 'material-ui/lib/svg-icons/action/perm-camera-mic';
import ActionOpenInNew from 'material-ui/lib/svg-icons/action/open-in-new';
import ActionTurnedInNot from 'material-ui/lib/svg-icons/action/turned-in-not';
import ActionThumbUp from 'material-ui/lib/svg-icons/action/thumb-up';
import ActionExitToApp from 'material-ui/lib/svg-icons/action/exit-to-app';
import ActionViewArray from 'material-ui/lib/svg-icons/action/view-array';
import ActionReceipt from 'material-ui/lib/svg-icons/action/receipt';
import ActionAspectRatio from 'material-ui/lib/svg-icons/action/aspect-ratio';
import ActionPlayForWork from 'material-ui/lib/svg-icons/action/play-for-work';
import ActionRedeem from 'material-ui/lib/svg-icons/action/redeem';
import ActionCheckCircle from 'material-ui/lib/svg-icons/action/check-circle';
import ActionHttp from 'material-ui/lib/svg-icons/action/http';
import ActionEvent from 'material-ui/lib/svg-icons/action/event';
import ActionStars from 'material-ui/lib/svg-icons/action/stars';
import ActionInvertColors from 'material-ui/lib/svg-icons/action/invert-colors';
import ActionSpeakerNotes from 'material-ui/lib/svg-icons/action/speaker-notes';
import ActionOpenWith from 'material-ui/lib/svg-icons/action/open-with';
import ActionHelp from 'material-ui/lib/svg-icons/action/help';
import ActionHourglassEmpty from 'material-ui/lib/svg-icons/action/hourglass-empty';
import ActionAssignmentInd from 'material-ui/lib/svg-icons/action/assignment-ind';
import ActionAssessment from 'material-ui/lib/svg-icons/action/assessment';
import ActionCode from 'material-ui/lib/svg-icons/action/code';
import ActionAlarm from 'material-ui/lib/svg-icons/action/alarm';
import ActionPowerSettingsNew from 'material-ui/lib/svg-icons/action/power-settings-new';
import ActionSystemUpdateAlt from 'material-ui/lib/svg-icons/action/system-update-alt';
import ActionToll from 'material-ui/lib/svg-icons/action/toll';
import ActionNoteAdd from 'material-ui/lib/svg-icons/action/note-add';
import ActionCardTravel from 'material-ui/lib/svg-icons/action/card-travel';
import ActionSettingsRemote from 'material-ui/lib/svg-icons/action/settings-remote';
import ActionBook from 'material-ui/lib/svg-icons/action/book';
import ActionStore from 'material-ui/lib/svg-icons/action/store';
import ActionSubject from 'material-ui/lib/svg-icons/action/subject';
import ActionViewCarousel from 'material-ui/lib/svg-icons/action/view-carousel';
import ActionReorder from 'material-ui/lib/svg-icons/action/reorder';
import ActionVisibility from 'material-ui/lib/svg-icons/action/visibility';
import ActionAccountBox from 'material-ui/lib/svg-icons/action/account-box';
import ActionFavorite from 'material-ui/lib/svg-icons/action/favorite';
import ActionSettingsInputHdmi from 'material-ui/lib/svg-icons/action/settings-input-hdmi';
import ActionTurnedIn from 'material-ui/lib/svg-icons/action/turned-in';
import ActionDescription from 'material-ui/lib/svg-icons/action/description';
import ActionHelpOutline from 'material-ui/lib/svg-icons/action/help-outline';
import ActionTrendingDown from 'material-ui/lib/svg-icons/action/trending-down';
import ActionFlightLand from 'material-ui/lib/svg-icons/action/flight-land';
import ActionFlipToFront from 'material-ui/lib/svg-icons/action/flip-to-front';
import ActionToday from 'material-ui/lib/svg-icons/action/today';
import ActionShoppingBasket from 'material-ui/lib/svg-icons/action/shopping-basket';
import ActionSettingsBrightness from 'material-ui/lib/svg-icons/action/settings-brightness';
import ActionPictureInPicture from 'material-ui/lib/svg-icons/action/picture-in-picture';
import ActionZoomIn from 'material-ui/lib/svg-icons/action/zoom-in';
import ActionShopTwo from 'material-ui/lib/svg-icons/action/shop-two';
import ActionClass from 'material-ui/lib/svg-icons/action/class';
import ActionSwapHoriz from 'material-ui/lib/svg-icons/action/swap-horiz';
import ActionPermScanWifi from 'material-ui/lib/svg-icons/action/perm-scan-wifi';
import ActionFlightTakeoff from 'material-ui/lib/svg-icons/action/flight-takeoff';
import ActionGrade from 'material-ui/lib/svg-icons/action/grade';
import ActionHome from 'material-ui/lib/svg-icons/action/home';
import ActionBackup from 'material-ui/lib/svg-icons/action/backup';
import ActionSettingsInputComponent from 'material-ui/lib/svg-icons/action/settings-input-component';
import ActionTranslate from 'material-ui/lib/svg-icons/action/translate';
import ActionSettingsVoice from 'material-ui/lib/svg-icons/action/settings-voice';
import ActionThumbsUpDown from 'material-ui/lib/svg-icons/action/thumbs-up-down';
import ActionViewQuilt from 'material-ui/lib/svg-icons/action/view-quilt';
import ActionDns from 'material-ui/lib/svg-icons/action/dns';
import ActionRestore from 'material-ui/lib/svg-icons/action/restore';
import ActionSettingsOverscan from 'material-ui/lib/svg-icons/action/settings-overscan';
import ActionDoneAll from 'material-ui/lib/svg-icons/action/done-all';
import ActionSupervisorAccount from 'material-ui/lib/svg-icons/action/supervisor-account';
import ActionLanguage from 'material-ui/lib/svg-icons/action/language';
import ActionPermIdentity from 'material-ui/lib/svg-icons/action/perm-identity';
import ActionYoutubeSearchedFor from 'material-ui/lib/svg-icons/action/youtube-searched-for';
import ActionAssignmentReturn from 'material-ui/lib/svg-icons/action/assignment-return';
import ActionAnnouncement from 'material-ui/lib/svg-icons/action/announcement';
import ActionSettingsPower from 'material-ui/lib/svg-icons/action/settings-power';
import ActionRoom from 'material-ui/lib/svg-icons/action/room';
import ActionFindReplace from 'material-ui/lib/svg-icons/action/find-replace';
import ActionThreeDRotation from 'material-ui/lib/svg-icons/action/three-d-rotation';
import ActionChromeReaderMode from 'material-ui/lib/svg-icons/action/chrome-reader-mode';
import ActionCameraEnhance from 'material-ui/lib/svg-icons/action/camera-enhance';
import ActionHistory from 'material-ui/lib/svg-icons/action/history';
import ActionSpellcheck from 'material-ui/lib/svg-icons/action/spellcheck';
import SocialNotificationsOff from 'material-ui/lib/svg-icons/social/notifications-off';
import SocialPersonAdd from 'material-ui/lib/svg-icons/social/person-add';
import SocialShare from 'material-ui/lib/svg-icons/social/share';
import SocialGroupAdd from 'material-ui/lib/svg-icons/social/group-add';
import SocialGroup from 'material-ui/lib/svg-icons/social/group';
import SocialNotificationsNone from 'material-ui/lib/svg-icons/social/notifications-none';
import SocialMoodBad from 'material-ui/lib/svg-icons/social/mood-bad';
import SocialPlusOne from 'material-ui/lib/svg-icons/social/plus-one';
import SocialMood from 'material-ui/lib/svg-icons/social/mood';
import SocialPersonOutline from 'material-ui/lib/svg-icons/social/person-outline';
import SocialPoll from 'material-ui/lib/svg-icons/social/poll';
import SocialLocationCity from 'material-ui/lib/svg-icons/social/location-city';
import SocialPerson from 'material-ui/lib/svg-icons/social/person';
import SocialPeopleOutline from 'material-ui/lib/svg-icons/social/people-outline';
import SocialCake from 'material-ui/lib/svg-icons/social/cake';
import SocialWhatshot from 'material-ui/lib/svg-icons/social/whatshot';
import SocialNotificationsPaused from 'material-ui/lib/svg-icons/social/notifications-paused';
import SocialPublic from 'material-ui/lib/svg-icons/social/public';
import SocialPages from 'material-ui/lib/svg-icons/social/pages';
import SocialPeople from 'material-ui/lib/svg-icons/social/people';
import SocialNotifications from 'material-ui/lib/svg-icons/social/notifications';
import SocialNotificationsActive from 'material-ui/lib/svg-icons/social/notifications-active';
import SocialSchool from 'material-ui/lib/svg-icons/social/school';
import SocialDomain from 'material-ui/lib/svg-icons/social/domain';
import SocialPartyMode from 'material-ui/lib/svg-icons/social/party-mode';
import AvNotInterested from 'material-ui/lib/svg-icons/av/not-interested';
import AvPauseCircleOutline from 'material-ui/lib/svg-icons/av/pause-circle-outline';
import AvNewReleases from 'material-ui/lib/svg-icons/av/new-releases';
import AvMic from 'material-ui/lib/svg-icons/av/mic';
import AvSkipPrevious from 'material-ui/lib/svg-icons/av/skip-previous';
import AvReplay5 from 'material-ui/lib/svg-icons/av/replay-5';
import AvMovie from 'material-ui/lib/svg-icons/av/movie';
import AvForward10 from 'material-ui/lib/svg-icons/av/forward-10';
import AvGames from 'material-ui/lib/svg-icons/av/games';
import AvHighQuality from 'material-ui/lib/svg-icons/av/high-quality';
import AvExplicit from 'material-ui/lib/svg-icons/av/explicit';
import AvHd from 'material-ui/lib/svg-icons/av/hd';
import AvAlbum from 'material-ui/lib/svg-icons/av/album';
import AvRepeatOne from 'material-ui/lib/svg-icons/av/repeat-one';
import AvSkipNext from 'material-ui/lib/svg-icons/av/skip-next';
import AvLibraryBooks from 'material-ui/lib/svg-icons/av/library-books';
import AvVolumeMute from 'material-ui/lib/svg-icons/av/volume-mute';
import AvLibraryMusic from 'material-ui/lib/svg-icons/av/library-music';
import AvPlayArrow from 'material-ui/lib/svg-icons/av/play-arrow';
import AvRadio from 'material-ui/lib/svg-icons/av/radio';
import AvFastRewind from 'material-ui/lib/svg-icons/av/fast-rewind';
import AvReplay from 'material-ui/lib/svg-icons/av/replay';
import AvHearing from 'material-ui/lib/svg-icons/av/hearing';
import AvPause from 'material-ui/lib/svg-icons/av/pause';
import AvEqualizer from 'material-ui/lib/svg-icons/av/equalizer';
import AvVolumeUp from 'material-ui/lib/svg-icons/av/volume-up';
import AvFastForward from 'material-ui/lib/svg-icons/av/fast-forward';
import AvSurroundSound from 'material-ui/lib/svg-icons/av/surround-sound';
import AvForward30 from 'material-ui/lib/svg-icons/av/forward-30';
import AvQueueMusic from 'material-ui/lib/svg-icons/av/queue-music';
import AvReplay30 from 'material-ui/lib/svg-icons/av/replay-30';
import AvSortByAlpha from 'material-ui/lib/svg-icons/av/sort-by-alpha';
import AvSubtitles from 'material-ui/lib/svg-icons/av/subtitles';
import AvClosedCaption from 'material-ui/lib/svg-icons/av/closed-caption';
import AvVideoLibrary from 'material-ui/lib/svg-icons/av/video-library';
import AvWeb from 'material-ui/lib/svg-icons/av/web';
import AvMicNone from 'material-ui/lib/svg-icons/av/mic-none';
import AvShuffle from 'material-ui/lib/svg-icons/av/shuffle';
import AvStop from 'material-ui/lib/svg-icons/av/stop';
import AvPlayCircleOutline from 'material-ui/lib/svg-icons/av/play-circle-outline';
import AvVideocamOff from 'material-ui/lib/svg-icons/av/videocam-off';
import AvQueue from 'material-ui/lib/svg-icons/av/queue';
import AvVolumeDown from 'material-ui/lib/svg-icons/av/volume-down';
import AvVideocam from 'material-ui/lib/svg-icons/av/videocam';
import AvRepeat from 'material-ui/lib/svg-icons/av/repeat';
import AvRecentActors from 'material-ui/lib/svg-icons/av/recent-actors';
import AvForward5 from 'material-ui/lib/svg-icons/av/forward-5';
import AvLoop from 'material-ui/lib/svg-icons/av/loop';
import AvLibraryAdd from 'material-ui/lib/svg-icons/av/library-add';
import AvPlayCircleFilled from 'material-ui/lib/svg-icons/av/play-circle-filled';
import AvPlaylistAdd from 'material-ui/lib/svg-icons/av/playlist-add';
import AvMicOff from 'material-ui/lib/svg-icons/av/mic-off';
import AvReplay10 from 'material-ui/lib/svg-icons/av/replay-10';
import AvAvTimer from 'material-ui/lib/svg-icons/av/av-timer';
import AvVolumeOff from 'material-ui/lib/svg-icons/av/volume-off';
import AvPauseCircleFilled from 'material-ui/lib/svg-icons/av/pause-circle-filled';
import AvAirplay from 'material-ui/lib/svg-icons/av/airplay';
import AvSnooze from 'material-ui/lib/svg-icons/av/snooze';
import ImageBrush from 'material-ui/lib/svg-icons/image/brush';
import ImageLooksOne from 'material-ui/lib/svg-icons/image/looks-one';
import ImageDetails from 'material-ui/lib/svg-icons/image/details';
import ImageTimer3 from 'material-ui/lib/svg-icons/image/timer-3';
import ImageFilterNone from 'material-ui/lib/svg-icons/image/filter-none';
import ImageLooks3 from 'material-ui/lib/svg-icons/image/looks-3';
import ImageFilter9 from 'material-ui/lib/svg-icons/image/filter-9';
import ImageFilter from 'material-ui/lib/svg-icons/image/filter';
import ImageAssistantPhoto from 'material-ui/lib/svg-icons/image/assistant-photo';
import ImageWbCloudy from 'material-ui/lib/svg-icons/image/wb-cloudy';
import ImageBrightness1 from 'material-ui/lib/svg-icons/image/brightness-1';
import ImagePanoramaWideAngle from 'material-ui/lib/svg-icons/image/panorama-wide-angle';
import ImagePanoramaFishEye from 'material-ui/lib/svg-icons/image/panorama-fish-eye';
import ImagePortrait from 'material-ui/lib/svg-icons/image/portrait';
import ImageBrightness5 from 'material-ui/lib/svg-icons/image/brightness-5';
import ImageExposureZero from 'material-ui/lib/svg-icons/image/exposure-zero';
import ImageExposureNeg2 from 'material-ui/lib/svg-icons/image/exposure-neg-2';
import ImageWbAuto from 'material-ui/lib/svg-icons/image/wb-auto';
import ImageHdrOff from 'material-ui/lib/svg-icons/image/hdr-off';
import ImageNaturePeople from 'material-ui/lib/svg-icons/image/nature-people';
import ImageAudiotrack from 'material-ui/lib/svg-icons/image/audiotrack';
import ImageCropPortrait from 'material-ui/lib/svg-icons/image/crop-portrait';
import ImageColorize from 'material-ui/lib/svg-icons/image/colorize';
import ImageCompare from 'material-ui/lib/svg-icons/image/compare';
import ImageFilter2 from 'material-ui/lib/svg-icons/image/filter-2';
import ImageTagFaces from 'material-ui/lib/svg-icons/image/tag-faces';
import ImageBlurCircular from 'material-ui/lib/svg-icons/image/blur-circular';
import ImageLens from 'material-ui/lib/svg-icons/image/lens';
import ImageTune from 'material-ui/lib/svg-icons/image/tune';
import ImageViewComfy from 'material-ui/lib/svg-icons/image/view-comfy';
import ImageCameraRoll from 'material-ui/lib/svg-icons/image/camera-roll';
import ImageCenterFocusStrong from 'material-ui/lib/svg-icons/image/center-focus-strong';
import ImageFlashOff from 'material-ui/lib/svg-icons/image/flash-off';
import ImageCollectionsBookmark from 'material-ui/lib/svg-icons/image/collections-bookmark';
import ImagePhotoSizeSelectActual from 'material-ui/lib/svg-icons/image/photo-size-select-actual';
import ImageImageAspectRatio from 'material-ui/lib/svg-icons/image/image-aspect-ratio';
import ImageFilterHdr from 'material-ui/lib/svg-icons/image/filter-hdr';
import ImageRotateRight from 'material-ui/lib/svg-icons/image/rotate-right';
import ImageFilterTiltShift from 'material-ui/lib/svg-icons/image/filter-tilt-shift';
import ImageCropFree from 'material-ui/lib/svg-icons/image/crop-free';
import ImageStyle from 'material-ui/lib/svg-icons/image/style';
import ImageNature from 'material-ui/lib/svg-icons/image/nature';
import ImagePhotoSizeSelectLarge from 'material-ui/lib/svg-icons/image/photo-size-select-large';
import ImageAdjust from 'material-ui/lib/svg-icons/image/adjust';
import ImageFlare from 'material-ui/lib/svg-icons/image/flare';
import ImageWbIridescent from 'material-ui/lib/svg-icons/image/wb-iridescent';
import ImageFilterDrama from 'material-ui/lib/svg-icons/image/filter-drama';
import ImageBrightness7 from 'material-ui/lib/svg-icons/image/brightness-7';
import ImageBlurOn from 'material-ui/lib/svg-icons/image/blur-on';
import ImageTimer10 from 'material-ui/lib/svg-icons/image/timer-10';
import ImageFlashOn from 'material-ui/lib/svg-icons/image/flash-on';
import ImagePhotoLibrary from 'material-ui/lib/svg-icons/image/photo-library';
import ImageBlurLinear from 'material-ui/lib/svg-icons/image/blur-linear';
import ImageCamera from 'material-ui/lib/svg-icons/image/camera';
import ImageTimelapse from 'material-ui/lib/svg-icons/image/timelapse';
import ImageLoupe from 'material-ui/lib/svg-icons/image/loupe';
import ImageExposurePlus1 from 'material-ui/lib/svg-icons/image/exposure-plus-1';
import ImageExposurePlus2 from 'material-ui/lib/svg-icons/image/exposure-plus-2';
import ImageFlashAuto from 'material-ui/lib/svg-icons/image/flash-auto';
import ImagePalette from 'material-ui/lib/svg-icons/image/palette';
import ImageCropDin from 'material-ui/lib/svg-icons/image/crop-din';
import ImageCrop169 from 'material-ui/lib/svg-icons/image/crop-16-9';
import ImageSlideshow from 'material-ui/lib/svg-icons/image/slideshow';
import ImageFilter1 from 'material-ui/lib/svg-icons/image/filter-1';
import ImageCrop75 from 'material-ui/lib/svg-icons/image/crop-7-5';
import ImageMusicNote from 'material-ui/lib/svg-icons/image/music-note';
import ImageCropLandscape from 'material-ui/lib/svg-icons/image/crop-landscape';
import ImageCrop32 from 'material-ui/lib/svg-icons/image/crop-3-2';
import ImageTimer from 'material-ui/lib/svg-icons/image/timer';
import ImageWbIncandescent from 'material-ui/lib/svg-icons/image/wb-incandescent';
import ImageLooks5 from 'material-ui/lib/svg-icons/image/looks-5';
import ImageGradient from 'material-ui/lib/svg-icons/image/gradient';
import ImageViewCompact from 'material-ui/lib/svg-icons/image/view-compact';
import ImageCenterFocusWeak from 'material-ui/lib/svg-icons/image/center-focus-weak';
import ImageLooks from 'material-ui/lib/svg-icons/image/looks';
import ImageCollections from 'material-ui/lib/svg-icons/image/collections';
import ImageMonochromePhotos from 'material-ui/lib/svg-icons/image/monochrome-photos';
import ImageBlurOff from 'material-ui/lib/svg-icons/image/blur-off';
import ImagePhotoSizeSelectSmall from 'material-ui/lib/svg-icons/image/photo-size-select-small';
import ImageFilter6 from 'material-ui/lib/svg-icons/image/filter-6';
import ImageCameraRear from 'material-ui/lib/svg-icons/image/camera-rear';
import ImageRotateLeft from 'material-ui/lib/svg-icons/image/rotate-left';
import ImageFilter7 from 'material-ui/lib/svg-icons/image/filter-7';
import ImageEdit from 'material-ui/lib/svg-icons/image/edit';
import ImageFilter9Plus from 'material-ui/lib/svg-icons/image/filter-9-plus';
import ImageLeakRemove from 'material-ui/lib/svg-icons/image/leak-remove';
import ImageTexture from 'material-ui/lib/svg-icons/image/texture';
import ImageBrightness6 from 'material-ui/lib/svg-icons/image/brightness-6';
import ImageCropOriginal from 'material-ui/lib/svg-icons/image/crop-original';
import ImageNavigateNext from 'material-ui/lib/svg-icons/image/navigate-next';
import ImageFilterCenterFocus from 'material-ui/lib/svg-icons/image/filter-center-focus';
import ImageAssistant from 'material-ui/lib/svg-icons/image/assistant';
import ImageFlip from 'material-ui/lib/svg-icons/image/flip';
import ImageCropSquare from 'material-ui/lib/svg-icons/image/crop-square';
import ImageVignette from 'material-ui/lib/svg-icons/image/vignette';
import ImageExposure from 'material-ui/lib/svg-icons/image/exposure';
import ImagePanoramaHorizontal from 'material-ui/lib/svg-icons/image/panorama-horizontal';
import ImagePanorama from 'material-ui/lib/svg-icons/image/panorama';
import ImageCrop from 'material-ui/lib/svg-icons/image/crop';
import ImageControlPoint from 'material-ui/lib/svg-icons/image/control-point';
import ImageRotate90DegreesCcw from 'material-ui/lib/svg-icons/image/rotate-90-degrees-ccw';
import ImageFilterBAndW from 'material-ui/lib/svg-icons/image/filter-b-and-w';
import ImageGridOff from 'material-ui/lib/svg-icons/image/grid-off';
import ImageBrightness3 from 'material-ui/lib/svg-icons/image/brightness-3';
import ImageFilter8 from 'material-ui/lib/svg-icons/image/filter-8';
import ImageLeakAdd from 'material-ui/lib/svg-icons/image/leak-add';
import ImageRemoveRedEye from 'material-ui/lib/svg-icons/image/remove-red-eye';
import ImagePhotoCamera from 'material-ui/lib/svg-icons/image/photo-camera';
import ImageStraighten from 'material-ui/lib/svg-icons/image/straighten';
import ImageFilter4 from 'material-ui/lib/svg-icons/image/filter-4';
import ImageGridOn from 'material-ui/lib/svg-icons/image/grid-on';
import ImageFilter3 from 'material-ui/lib/svg-icons/image/filter-3';
import ImageLandscape from 'material-ui/lib/svg-icons/image/landscape';
import ImageFilterFrames from 'material-ui/lib/svg-icons/image/filter-frames';
import ImageIso from 'material-ui/lib/svg-icons/image/iso';
import ImageTonality from 'material-ui/lib/svg-icons/image/tonality';
import ImageDehaze from 'material-ui/lib/svg-icons/image/dehaze';
import ImageHdrStrong from 'material-ui/lib/svg-icons/image/hdr-strong';
import ImageHealing from 'material-ui/lib/svg-icons/image/healing';
import ImageHdrWeak from 'material-ui/lib/svg-icons/image/hdr-weak';
import ImageFilterVintage from 'material-ui/lib/svg-icons/image/filter-vintage';
import ImageFilter5 from 'material-ui/lib/svg-icons/image/filter-5';
import ImageImage from 'material-ui/lib/svg-icons/image/image';
import ImageColorLens from 'material-ui/lib/svg-icons/image/color-lens';
import ImageLooks4 from 'material-ui/lib/svg-icons/image/looks-4';
import ImagePanoramaVertical from 'material-ui/lib/svg-icons/image/panorama-vertical';
import ImageBrightness4 from 'material-ui/lib/svg-icons/image/brightness-4';
import ImageLooks6 from 'material-ui/lib/svg-icons/image/looks-6';
import ImageControlPointDuplicate from 'material-ui/lib/svg-icons/image/control-point-duplicate';
import ImageCrop54 from 'material-ui/lib/svg-icons/image/crop-5-4';
import ImageHdrOn from 'material-ui/lib/svg-icons/image/hdr-on';
import ImagePhotoAlbum from 'material-ui/lib/svg-icons/image/photo-album';
import ImageNavigateBefore from 'material-ui/lib/svg-icons/image/navigate-before';
import ImageSwitchVideo from 'material-ui/lib/svg-icons/image/switch-video';
import ImageWbSunny from 'material-ui/lib/svg-icons/image/wb-sunny';
import ImageAddToPhotos from 'material-ui/lib/svg-icons/image/add-to-photos';
import ImagePhoto from 'material-ui/lib/svg-icons/image/photo';
import ImageBrokenImage from 'material-ui/lib/svg-icons/image/broken-image';
import ImagePictureAsPdf from 'material-ui/lib/svg-icons/image/picture-as-pdf';
import ImageTransform from 'material-ui/lib/svg-icons/image/transform';
import ImageCameraAlt from 'material-ui/lib/svg-icons/image/camera-alt';
import ImageBrightness2 from 'material-ui/lib/svg-icons/image/brightness-2';
import ImageMovieCreation from 'material-ui/lib/svg-icons/image/movie-creation';
import ImageGrain from 'material-ui/lib/svg-icons/image/grain';
import ImageLooksTwo from 'material-ui/lib/svg-icons/image/looks-two';
import ImageTimerOff from 'material-ui/lib/svg-icons/image/timer-off';
import ImageExposureNeg1 from 'material-ui/lib/svg-icons/image/exposure-neg-1';
import ImageCameraFront from 'material-ui/lib/svg-icons/image/camera-front';
import ImageSwitchCamera from 'material-ui/lib/svg-icons/image/switch-camera';
import ContentForward from 'material-ui/lib/svg-icons/content/forward';
import ContentSelectAll from 'material-ui/lib/svg-icons/content/select-all';
import ContentDrafts from 'material-ui/lib/svg-icons/content/drafts';
import ContentContentCopy from 'material-ui/lib/svg-icons/content/content-copy';
import ContentFlag from 'material-ui/lib/svg-icons/content/flag';
import ContentTextFormat from 'material-ui/lib/svg-icons/content/text-format';
import ContentReplyAll from 'material-ui/lib/svg-icons/content/reply-all';
import ContentReply from 'material-ui/lib/svg-icons/content/reply';
import ContentRemoveCircle from 'material-ui/lib/svg-icons/content/remove-circle';
import ContentAddCircle from 'material-ui/lib/svg-icons/content/add-circle';
import ContentLink from 'material-ui/lib/svg-icons/content/link';
import ContentMail from 'material-ui/lib/svg-icons/content/mail';
import ContentArchive from 'material-ui/lib/svg-icons/content/archive';
import ContentSave from 'material-ui/lib/svg-icons/content/save';
import ContentRemove from 'material-ui/lib/svg-icons/content/remove';
import ContentFontDownload from 'material-ui/lib/svg-icons/content/font-download';
import ContentRemoveCircleOutline from 'material-ui/lib/svg-icons/content/remove-circle-outline';
import ContentCreate from 'material-ui/lib/svg-icons/content/create';
import ContentClear from 'material-ui/lib/svg-icons/content/clear';
import ContentContentCut from 'material-ui/lib/svg-icons/content/content-cut';
import ContentRedo from 'material-ui/lib/svg-icons/content/redo';
import ContentMarkunread from 'material-ui/lib/svg-icons/content/markunread';
import ContentContentPaste from 'material-ui/lib/svg-icons/content/content-paste';
import ContentBackspace from 'material-ui/lib/svg-icons/content/backspace';
import ContentReport from 'material-ui/lib/svg-icons/content/report';
import ContentSort from 'material-ui/lib/svg-icons/content/sort';
import ContentInbox from 'material-ui/lib/svg-icons/content/inbox';
import ContentGesture from 'material-ui/lib/svg-icons/content/gesture';
import ContentBlock from 'material-ui/lib/svg-icons/content/block';
import ContentAdd from 'material-ui/lib/svg-icons/content/add';
import ContentUndo from 'material-ui/lib/svg-icons/content/undo';
import ContentAddBox from 'material-ui/lib/svg-icons/content/add-box';
import ContentAddCircleOutline from 'material-ui/lib/svg-icons/content/add-circle-outline';
import ContentFilterList from 'material-ui/lib/svg-icons/content/filter-list';
import ContentSend from 'material-ui/lib/svg-icons/content/send';
import NotificationSyncProblem from 'material-ui/lib/svg-icons/notification/sync-problem';
import NotificationAirlineSeatIndividualSuite from 'material-ui/lib/svg-icons/notification/airline-seat-individual-suite';
import NotificationVpnLock from 'material-ui/lib/svg-icons/notification/vpn-lock';
import NotificationAirlineSeatLegroomExtra from 'material-ui/lib/svg-icons/notification/airline-seat-legroom-extra';
import NotificationWifi from 'material-ui/lib/svg-icons/notification/wifi';
import NotificationTapAndPlay from 'material-ui/lib/svg-icons/notification/tap-and-play';
import NotificationAirlineSeatFlatAngled from 'material-ui/lib/svg-icons/notification/airline-seat-flat-angled';
import NotificationWc from 'material-ui/lib/svg-icons/notification/wc';
import NotificationSms from 'material-ui/lib/svg-icons/notification/sms';
import NotificationBluetoothAudio from 'material-ui/lib/svg-icons/notification/bluetooth-audio';
import NotificationFolderSpecial from 'material-ui/lib/svg-icons/notification/folder-special';
import NotificationSimCardAlert from 'material-ui/lib/svg-icons/notification/sim-card-alert';
import NotificationEventNote from 'material-ui/lib/svg-icons/notification/event-note';
import NotificationPersonalVideo from 'material-ui/lib/svg-icons/notification/personal-video';
import NotificationLiveTv from 'material-ui/lib/svg-icons/notification/live-tv';
import NotificationTimeToLeave from 'material-ui/lib/svg-icons/notification/time-to-leave';
import NotificationAdb from 'material-ui/lib/svg-icons/notification/adb';
import NotificationConfirmationNumber from 'material-ui/lib/svg-icons/notification/confirmation-number';
import NotificationAirlineSeatFlat from 'material-ui/lib/svg-icons/notification/airline-seat-flat';
import NotificationSync from 'material-ui/lib/svg-icons/notification/sync';
import NotificationVoiceChat from 'material-ui/lib/svg-icons/notification/voice-chat';
import NotificationPhoneLocked from 'material-ui/lib/svg-icons/notification/phone-locked';
import NotificationPhoneForwarded from 'material-ui/lib/svg-icons/notification/phone-forwarded';
import NotificationSystemUpdate from 'material-ui/lib/svg-icons/notification/system-update';
import NotificationMore from 'material-ui/lib/svg-icons/notification/more';
import NotificationMms from 'material-ui/lib/svg-icons/notification/mms';
import NotificationPhoneInTalk from 'material-ui/lib/svg-icons/notification/phone-in-talk';
import NotificationAirlineSeatReclineExtra from 'material-ui/lib/svg-icons/notification/airline-seat-recline-extra';
import NotificationPhoneBluetoothSpeaker from 'material-ui/lib/svg-icons/notification/phone-bluetooth-speaker';
import NotificationAirlineSeatLegroomNormal from 'material-ui/lib/svg-icons/notification/airline-seat-legroom-normal';
import NotificationDoNotDisturbAlt from 'material-ui/lib/svg-icons/notification/do-not-disturb-alt';
import NotificationOndemandVideo from 'material-ui/lib/svg-icons/notification/ondemand-video';
import NotificationEventBusy from 'material-ui/lib/svg-icons/notification/event-busy';
import NotificationDoNotDisturb from 'material-ui/lib/svg-icons/notification/do-not-disturb';
import NotificationDriveEta from 'material-ui/lib/svg-icons/notification/drive-eta';
import NotificationAirlineSeatLegroomReduced from 'material-ui/lib/svg-icons/notification/airline-seat-legroom-reduced';
import NotificationSyncDisabled from 'material-ui/lib/svg-icons/notification/sync-disabled';
import NotificationPhoneMissed from 'material-ui/lib/svg-icons/notification/phone-missed';
import NotificationEventAvailable from 'material-ui/lib/svg-icons/notification/event-available';
import NotificationAirlineSeatReclineNormal from 'material-ui/lib/svg-icons/notification/airline-seat-recline-normal';
import NotificationVibration from 'material-ui/lib/svg-icons/notification/vibration';
import NotificationPower from 'material-ui/lib/svg-icons/notification/power';
import NotificationSdCard from 'material-ui/lib/svg-icons/notification/sd-card';
import NotificationPhonePaused from 'material-ui/lib/svg-icons/notification/phone-paused';
import NotificationDiscFull from 'material-ui/lib/svg-icons/notification/disc-full';
import NotificationSmsFailed from 'material-ui/lib/svg-icons/notification/sms-failed';
import NotificationNetworkLocked from 'material-ui/lib/svg-icons/notification/network-locked';
import HardwarePowerInput from 'material-ui/lib/svg-icons/hardware/power-input';
import HardwareWatch from 'material-ui/lib/svg-icons/hardware/watch';
import HardwareGamepad from 'material-ui/lib/svg-icons/hardware/gamepad';
import HardwareLaptop from 'material-ui/lib/svg-icons/hardware/laptop';
import HardwareKeyboardBackspace from 'material-ui/lib/svg-icons/hardware/keyboard-backspace';
import HardwareSmartphone from 'material-ui/lib/svg-icons/hardware/smartphone';
import HardwarePhonelinkOff from 'material-ui/lib/svg-icons/hardware/phonelink-off';
import HardwarePhoneAndroid from 'material-ui/lib/svg-icons/hardware/phone-android';
import HardwareMouse from 'material-ui/lib/svg-icons/hardware/mouse';
import HardwareLaptopChromebook from 'material-ui/lib/svg-icons/hardware/laptop-chromebook';
import HardwareSecurity from 'material-ui/lib/svg-icons/hardware/security';
import HardwareTv from 'material-ui/lib/svg-icons/hardware/tv';
import HardwareSpeakerGroup from 'material-ui/lib/svg-icons/hardware/speaker-group';
import HardwareKeyboardArrowUp from 'material-ui/lib/svg-icons/hardware/keyboard-arrow-up';
import HardwareSimCard from 'material-ui/lib/svg-icons/hardware/sim-card';
import HardwareCastConnected from 'material-ui/lib/svg-icons/hardware/cast-connected';
import HardwareMemory from 'material-ui/lib/svg-icons/hardware/memory';
import HardwareDesktopMac from 'material-ui/lib/svg-icons/hardware/desktop-mac';
import HardwareDesktopWindows from 'material-ui/lib/svg-icons/hardware/desktop-windows';
import HardwareSpeaker from 'material-ui/lib/svg-icons/hardware/speaker';
import HardwareToys from 'material-ui/lib/svg-icons/hardware/toys';
import HardwareKeyboardHide from 'material-ui/lib/svg-icons/hardware/keyboard-hide';
import HardwareRouter from 'material-ui/lib/svg-icons/hardware/router';
import HardwareTabletAndroid from 'material-ui/lib/svg-icons/hardware/tablet-android';
import HardwareHeadset from 'material-ui/lib/svg-icons/hardware/headset';
import HardwareLaptopWindows from 'material-ui/lib/svg-icons/hardware/laptop-windows';
import HardwareKeyboardArrowLeft from 'material-ui/lib/svg-icons/hardware/keyboard-arrow-left';
import HardwareLaptopMac from 'material-ui/lib/svg-icons/hardware/laptop-mac';
import HardwareTabletMac from 'material-ui/lib/svg-icons/hardware/tablet-mac';
import HardwareKeyboardArrowRight from 'material-ui/lib/svg-icons/hardware/keyboard-arrow-right';
import HardwareKeyboard from 'material-ui/lib/svg-icons/hardware/keyboard';
import HardwarePhoneIphone from 'material-ui/lib/svg-icons/hardware/phone-iphone';
import HardwareDeveloperBoard from 'material-ui/lib/svg-icons/hardware/developer-board';
import HardwareDeviceHub from 'material-ui/lib/svg-icons/hardware/device-hub';
import HardwareKeyboardReturn from 'material-ui/lib/svg-icons/hardware/keyboard-return';
import HardwareHeadsetMic from 'material-ui/lib/svg-icons/hardware/headset-mic';
import HardwareTablet from 'material-ui/lib/svg-icons/hardware/tablet';
import HardwarePhonelink from 'material-ui/lib/svg-icons/hardware/phonelink';
import HardwareKeyboardTab from 'material-ui/lib/svg-icons/hardware/keyboard-tab';
import HardwareComputer from 'material-ui/lib/svg-icons/hardware/computer';
import HardwareCast from 'material-ui/lib/svg-icons/hardware/cast';
import HardwareKeyboardArrowDown from 'material-ui/lib/svg-icons/hardware/keyboard-arrow-down';
import HardwareDock from 'material-ui/lib/svg-icons/hardware/dock';
import HardwareKeyboardVoice from 'material-ui/lib/svg-icons/hardware/keyboard-voice';
import HardwareScanner from 'material-ui/lib/svg-icons/hardware/scanner';
import HardwareKeyboardCapslock from 'material-ui/lib/svg-icons/hardware/keyboard-capslock';
import AlertWarning from 'material-ui/lib/svg-icons/alert/warning';
import AlertErrorOutline from 'material-ui/lib/svg-icons/alert/error-outline';
import AlertAddAlert from 'material-ui/lib/svg-icons/alert/add-alert';
import AlertError from 'material-ui/lib/svg-icons/alert/error';
import DeviceNetworkWifi from 'material-ui/lib/svg-icons/device/network-wifi';
import DeviceSignalWifi0Bar from 'material-ui/lib/svg-icons/device/signal-wifi-0-bar';
import DeviceSignalCellular4Bar from 'material-ui/lib/svg-icons/device/signal-cellular-4-bar';
import DeviceAccessAlarm from 'material-ui/lib/svg-icons/device/access-alarm';
import DeviceWallpaper from 'material-ui/lib/svg-icons/device/wallpaper';
import DeviceDataUsage from 'material-ui/lib/svg-icons/device/data-usage';
import DeviceSignalCellularConnectedNoInternet1Bar from 'material-ui/lib/svg-icons/device/signal-cellular-connected-no-internet-1-bar';
import DeviceBatteryCharging80 from 'material-ui/lib/svg-icons/device/battery-charging-80';
import DeviceLocationSearching from 'material-ui/lib/svg-icons/device/location-searching';
import DeviceSignalCellular0Bar from 'material-ui/lib/svg-icons/device/signal-cellular-0-bar';
import DeviceSettingsSystemDaydream from 'material-ui/lib/svg-icons/device/settings-system-daydream';
import DeviceBatteryChargingFull from 'material-ui/lib/svg-icons/device/battery-charging-full';
import DeviceScreenLockLandscape from 'material-ui/lib/svg-icons/device/screen-lock-landscape';
import DeviceBluetoothConnected from 'material-ui/lib/svg-icons/device/bluetooth-connected';
import DeviceSdStorage from 'material-ui/lib/svg-icons/device/sd-storage';
import DeviceWidgets from 'material-ui/lib/svg-icons/device/widgets';
import DeviceBrightnessHigh from 'material-ui/lib/svg-icons/device/brightness-high';
import DeviceWifiLock from 'material-ui/lib/svg-icons/device/wifi-lock';
import DeviceBatteryCharging60 from 'material-ui/lib/svg-icons/device/battery-charging-60';
import DeviceBrightnessAuto from 'material-ui/lib/svg-icons/device/brightness-auto';
import DeviceBattery60 from 'material-ui/lib/svg-icons/device/battery-60';
import DeviceBatteryCharging20 from 'material-ui/lib/svg-icons/device/battery-charging-20';
import DeviceSignalCellular3Bar from 'material-ui/lib/svg-icons/device/signal-cellular-3-bar';
import DeviceSignalCellular2Bar from 'material-ui/lib/svg-icons/device/signal-cellular-2-bar';
import DeviceBatteryCharging50 from 'material-ui/lib/svg-icons/device/battery-charging-50';
import DeviceBattery50 from 'material-ui/lib/svg-icons/device/battery-50';
import DeviceWifiTethering from 'material-ui/lib/svg-icons/device/wifi-tethering';
import DeviceBattery20 from 'material-ui/lib/svg-icons/device/battery-20';
import DeviceSignalCellularConnectedNoInternet2Bar from 'material-ui/lib/svg-icons/device/signal-cellular-connected-no-internet-2-bar';
import DeviceAccessAlarms from 'material-ui/lib/svg-icons/device/access-alarms';
import DeviceSignalWifi1Bar from 'material-ui/lib/svg-icons/device/signal-wifi-1-bar';
import DeviceScreenLockPortrait from 'material-ui/lib/svg-icons/device/screen-lock-portrait';
import DeviceAccessTime from 'material-ui/lib/svg-icons/device/access-time';
import DeviceBattery80 from 'material-ui/lib/svg-icons/device/battery-80';
import DeviceGpsOff from 'material-ui/lib/svg-icons/device/gps-off';
import DeviceScreenLockRotation from 'material-ui/lib/svg-icons/device/screen-lock-rotation';
import DeviceBatteryUnknown from 'material-ui/lib/svg-icons/device/battery-unknown';
import DeviceGpsNotFixed from 'material-ui/lib/svg-icons/device/gps-not-fixed';
import DeviceSignalWifi3BarLock from 'material-ui/lib/svg-icons/device/signal-wifi-3-bar-lock';
import DeviceNfc from 'material-ui/lib/svg-icons/device/nfc';
import DeviceDvr from 'material-ui/lib/svg-icons/device/dvr';
import DeviceSignalCellular1Bar from 'material-ui/lib/svg-icons/device/signal-cellular-1-bar';
import DeviceAirplanemodeActive from 'material-ui/lib/svg-icons/device/airplanemode-active';
import DeviceBattery90 from 'material-ui/lib/svg-icons/device/battery-90';
import DeviceBluetoothSearching from 'material-ui/lib/svg-icons/device/bluetooth-searching';
import DeviceStorage from 'material-ui/lib/svg-icons/device/storage';
import DeviceSignalCellularNoSim from 'material-ui/lib/svg-icons/device/signal-cellular-no-sim';
import DeviceBrightnessMedium from 'material-ui/lib/svg-icons/device/brightness-medium';
import DeviceLocationDisabled from 'material-ui/lib/svg-icons/device/location-disabled';
import DeviceSignalWifi2BarLock from 'material-ui/lib/svg-icons/device/signal-wifi-2-bar-lock';
import DeviceSignalWifiOff from 'material-ui/lib/svg-icons/device/signal-wifi-off';
import DeviceBatteryFull from 'material-ui/lib/svg-icons/device/battery-full';
import DeviceBluetooth from 'material-ui/lib/svg-icons/device/bluetooth';
import DeviceSignalCellularConnectedNoInternet3Bar from 'material-ui/lib/svg-icons/device/signal-cellular-connected-no-internet-3-bar';
import DeviceSignalWifi1BarLock from 'material-ui/lib/svg-icons/device/signal-wifi-1-bar-lock';
import DeviceSignalCellularNull from 'material-ui/lib/svg-icons/device/signal-cellular-null';
import DeviceBrightnessLow from 'material-ui/lib/svg-icons/device/brightness-low';
import DeviceBatteryCharging90 from 'material-ui/lib/svg-icons/device/battery-charging-90';
import DeviceSignalWifi3Bar from 'material-ui/lib/svg-icons/device/signal-wifi-3-bar';
import DeviceSignalCellularOff from 'material-ui/lib/svg-icons/device/signal-cellular-off';
import DeviceSignalCellularConnectedNoInternet0Bar from 'material-ui/lib/svg-icons/device/signal-cellular-connected-no-internet-0-bar';
import DeviceBluetoothDisabled from 'material-ui/lib/svg-icons/device/bluetooth-disabled';
import DeviceDevices from 'material-ui/lib/svg-icons/device/devices';
import DeviceAddAlarm from 'material-ui/lib/svg-icons/device/add-alarm';
import DeviceGraphicEq from 'material-ui/lib/svg-icons/device/graphic-eq';
import DeviceBatteryAlert from 'material-ui/lib/svg-icons/device/battery-alert';
import DeviceSignalWifi4BarLock from 'material-ui/lib/svg-icons/device/signal-wifi-4-bar-lock';
import DeviceSignalWifi4Bar from 'material-ui/lib/svg-icons/device/signal-wifi-4-bar';
import DeviceSignalCellularConnectedNoInternet4Bar from 'material-ui/lib/svg-icons/device/signal-cellular-connected-no-internet-4-bar';
import DeviceDeveloperMode from 'material-ui/lib/svg-icons/device/developer-mode';
import DeviceGpsFixed from 'material-ui/lib/svg-icons/device/gps-fixed';
import DeviceBatteryStd from 'material-ui/lib/svg-icons/device/battery-std';
import DeviceBattery30 from 'material-ui/lib/svg-icons/device/battery-30';
import DeviceAirplanemodeInactive from 'material-ui/lib/svg-icons/device/airplanemode-inactive';
import DeviceSignalWifi2Bar from 'material-ui/lib/svg-icons/device/signal-wifi-2-bar';
import DeviceNetworkCell from 'material-ui/lib/svg-icons/device/network-cell';
import DeviceUsb from 'material-ui/lib/svg-icons/device/usb';
import DeviceBatteryCharging30 from 'material-ui/lib/svg-icons/device/battery-charging-30';
import DeviceScreenRotation from 'material-ui/lib/svg-icons/device/screen-rotation';

export {
  MapsDirectionsRailway,
  MapsDirectionsSubway,
  MapsSatellite,
  MapsDirectionsCar,
  MapsDirectionsWalk,
  MapsLayersClear,
  MapsLocalPharmacy,
  MapsPlace,
  MapsHotel,
  MapsDirectionsBike,
  MapsLocalMall,
  MapsMyLocation,
  MapsLocalOffer,
  MapsLocalSee,
  MapsLocalCarWash,
  MapsLocalPostOffice,
  MapsDirections,
  MapsLocalMovies,
  MapsRestaurantMenu,
  MapsDirectionsBoat,
  MapsLocalCafe,
  MapsTerrain,
  MapsLocalPhone,
  MapsLocalHotel,
  MapsLocalPlay,
  MapsLocalPizza,
  MapsLocalAirport,
  MapsLocalShipping,
  MapsLocalParking,
  MapsNavigation,
  MapsMap,
  MapsPinDrop,
  MapsLocalHospital,
  MapsDirectionsRun,
  MapsTraffic,
  MapsLayers,
  MapsLocalDrink,
  MapsLocalGroceryStore,
  MapsLocalDining,
  MapsLocalTaxi,
  MapsPersonPin,
  MapsLocalGasStation,
  MapsFlight,
  MapsLocalActivity,
  MapsLocalFlorist,
  MapsLocalBar,
  MapsDirectionsTransit,
  MapsLocalPrintshop,
  MapsLocalAtm,
  MapsStoreMallDirectory,
  MapsLocalConvenienceStore,
  MapsRateReview,
  MapsLocalLibrary,
  MapsLocalLaundryService,
  MapsBeenhere,
  MapsDirectionsBus,
  NavigationMoreHoriz,
  NavigationFullscreen,
  NavigationCheck,
  NavigationRefresh,
  NavigationArrowDropDownCircle,
  NavigationMenu,
  NavigationExpandMore,
  NavigationUnfoldLess,
  NavigationArrowForward,
  NavigationFullscreenExit,
  NavigationApps,
  NavigationArrowBack,
  NavigationArrowDropUp,
  NavigationClose,
  NavigationChevronRight,
  NavigationExpandLess,
  NavigationMoreVert,
  NavigationArrowDropDown,
  NavigationChevronLeft,
  NavigationUnfoldMore,
  NavigationCancel,
  EditorVerticalAlignBottom,
  EditorFormatPaint,
  EditorBorderHorizontal,
  EditorFormatAlignRight,
  EditorBorderStyle,
  EditorBorderInner,
  EditorFormatTextdirectionLToR,
  EditorBorderColor,
  EditorFormatAlignCenter,
  EditorFormatStrikethrough,
  EditorFormatListBulleted,
  EditorFunctions,
  EditorFormatColorText,
  EditorFormatColorFill,
  EditorModeEdit,
  EditorWrapText,
  EditorMergeType,
  EditorBorderVertical,
  EditorVerticalAlignCenter,
  EditorBorderLeft,
  EditorFormatListNumbered,
  EditorBorderRight,
  EditorFormatLineSpacing,
  EditorFormatIndentDecrease,
  EditorBorderTop,
  EditorModeComment,
  EditorFormatColorReset,
  EditorMoneyOff,
  EditorSpaceBar,
  EditorInsertEmoticon,
  EditorFormatQuote,
  EditorVerticalAlignTop,
  EditorFormatAlignLeft,
  EditorAttachMoney,
  EditorBorderBottom,
  EditorFormatTextdirectionRToL,
  EditorFormatClear,
  EditorInsertDriveFile,
  EditorFormatIndentIncrease,
  EditorInsertChart,
  EditorInsertComment,
  EditorFormatBold,
  EditorFormatSize,
  EditorBorderClear,
  EditorPublish,
  EditorAttachFile,
  EditorBorderAll,
  EditorStrikethroughS,
  EditorFormatUnderlined,
  EditorInsertInvitation,
  EditorInsertLink,
  EditorBorderOuter,
  EditorFormatAlignJustify,
  EditorInsertPhoto,
  EditorFormatItalic,
  NavigationArrowDropRight,
  ToggleCheckBox,
  ToggleStar,
  ToggleCheckBoxOutlineBlank,
  ToggleStarHalf,
  ToggleStarBorder,
  ToggleIndeterminateCheckBox,
  ToggleRadioButtonUnchecked,
  ToggleRadioButtonChecked,
  FileCloudOff,
  FileCloud,
  FileCloudDownload,
  FileFolderOpen,
  FileFileUpload,
  FileCloudUpload,
  FileFileDownload,
  FileCloudDone,
  FileAttachment,
  FileFolderShared,
  FileCloudQueue,
  FileCloudCircle,
  FileFolder,
  CommunicationMessage,
  CommunicationSpeakerPhone,
  CommunicationForum,
  CommunicationLocationOn,
  CommunicationDialpad,
  CommunicationContacts,
  CommunicationLocationOff,
  CommunicationChatBubbleOutline,
  CommunicationStayCurrentPortrait,
  CommunicationCallSplit,
  CommunicationCallMissed,
  CommunicationChatBubble,
  CommunicationPresentToAll,
  CommunicationStayPrimaryPortrait,
  CommunicationCallReceived,
  CommunicationStayPrimaryLandscape,
  CommunicationPhonelinkErase,
  CommunicationInvertColorsOff,
  CommunicationCallMerge,
  CommunicationPhonelinkLock,
  CommunicationLiveHelp,
  CommunicationSwapCalls,
  CommunicationTactMail,
  CommunicationContactPhone,
  CommunicationPortableWifiOff,
  CommunicationDialerSip,
  CommunicationNoSim,
  CommunicationStayCurrentLandscape,
  CommunicationCall,
  CommunicationVpnKey,
  CommunicationVoicemail,
  CommunicationPhonelinkRing,
  CommunicationBusiness,
  CommunicationImportExport,
  CommunicationClearAll,
  CommunicationEmail,
  CommunicationComment,
  CommunicationTextsms,
  CommunicationPhonelinkSetup,
  CommunicationCallEnd,
  CommunicationCallMade,
  CommunicationChat,
  CommunicationPhone,
  CommunicationRingVolume,
  ActionSettingsEthernet,
  ActionAssignmentReturned,
  ActionLockOpen,
  ActionReportProblem,
  ActionList,
  ActionSwapVert,
  ActionTab,
  ActionInfoOutline,
  ActionTabUnselected,
  ActionGif,
  ActionPolymer,
  ActionExplore,
  ActionThumbDown,
  ActionViewHeadline,
  ActionPageview,
  ActionFavoriteBorder,
  ActionPermPhoneMsg,
  ActionSettingsInputAntenna,
  ActionAssignment,
  ActionGetApp,
  ActionPermMedia,
  ActionFindInPage,
  ActionSettingsBluetooth,
  ActionCreditCard,
  ActionViewWeek,
  ActionTrackChanges,
  ActionCardGiftcard,
  ActionSettingsBackupRestore,
  ActionBugReport,
  ActionHighlightOff,
  ActionChangeHistory,
  ActionViewAgenda,
  ActionDone,
  ActionLockOutline,
  ActionHourglassFull,
  ActionLabel,
  ActionBookmark,
  ActionSwapVerticalCircle,
  ActionEject,
  ActionTrendingFlat,
  ActionGroupWork,
  ActionSettingsInputSvideo,
  ActionPermContactCalendar,
  ActionFace,
  ActionVerifiedUser,
  ActionTheaters,
  ActionBuild,
  ActionPermDataSetting,
  ActionQuestionAnswer,
  ActionFlipToBack,
  ActionExtension,
  ActionAccessibility,
  ActionAlarmOn,
  ActionQueryBuilder,
  ActionAddShoppingCart,
  ActionPayment,
  ActionEventSeat,
  ActionInput,
  ActionMarkunreadMailbox,
  ActionLoyalty,
  ActionPrint,
  ActionAutorenew,
  ActionDelete,
  ActionAlarmAdd,
  ActionAccountBalance,
  ActionAndroid,
  ActionBookmarkBorder,
  ActionLaunch,
  ActionSearch,
  ActionZoomOut,
  ActionVisibilityOff,
  ActionLock,
  ActionAccountCircle,
  ActionAssignmentLate,
  ActionShop,
  ActionToc,
  ActionShoppingCart,
  ActionCardMembership,
  ActionLabelOutline,
  ActionSettings,
  ActionSettingsCell,
  ActionOfflinePin,
  ActionViewDay,
  ActionDashboard,
  ActionViewModule,
  ActionSettingsApplications,
  ActionViewStream,
  ActionViewColumn,
  ActionSettingsInputComposite,
  ActionAccountBalanceWallet,
  ActionInfo,
  ActionAssignmentTurnedIn,
  ActionSchedule,
  ActionPermDeviceInformation,
  ActionViewList,
  ActionOpenInBrowser,
  ActionSettingsPhone,
  ActionFeedback,
  ActionHttps,
  ActionAlarmOff,
  ActionCached,
  ActionTrendingUp,
  ActionWork,
  ActionPermCameraMic,
  ActionOpenInNew,
  ActionTurnedInNot,
  ActionThumbUp,
  ActionExitToApp,
  ActionViewArray,
  ActionReceipt,
  ActionAspectRatio,
  ActionPlayForWork,
  ActionRedeem,
  ActionCheckCircle,
  ActionHttp,
  ActionEvent,
  ActionStars,
  ActionInvertColors,
  ActionSpeakerNotes,
  ActionOpenWith,
  ActionHelp,
  ActionHourglassEmpty,
  ActionAssignmentInd,
  ActionAssessment,
  ActionCode,
  ActionAlarm,
  ActionPowerSettingsNew,
  ActionSystemUpdateAlt,
  ActionToll,
  ActionNoteAdd,
  ActionCardTravel,
  ActionSettingsRemote,
  ActionBook,
  ActionStore,
  ActionSubject,
  ActionViewCarousel,
  ActionReorder,
  ActionVisibility,
  ActionAccountBox,
  ActionFavorite,
  ActionSettingsInputHdmi,
  ActionTurnedIn,
  ActionDescription,
  ActionHelpOutline,
  ActionTrendingDown,
  ActionFlightLand,
  ActionFlipToFront,
  ActionToday,
  ActionShoppingBasket,
  ActionSettingsBrightness,
  ActionPictureInPicture,
  ActionZoomIn,
  ActionShopTwo,
  ActionClass,
  ActionSwapHoriz,
  ActionPermScanWifi,
  ActionFlightTakeoff,
  ActionGrade,
  ActionHome,
  ActionBackup,
  ActionSettingsInputComponent,
  ActionTranslate,
  ActionSettingsVoice,
  ActionThumbsUpDown,
  ActionViewQuilt,
  ActionDns,
  ActionRestore,
  ActionSettingsOverscan,
  ActionDoneAll,
  ActionSupervisorAccount,
  ActionLanguage,
  ActionPermIdentity,
  ActionYoutubeSearchedFor,
  ActionAssignmentReturn,
  ActionAnnouncement,
  ActionSettingsPower,
  ActionRoom,
  ActionFindReplace,
  ActionThreeDRotation,
  ActionChromeReaderMode,
  ActionCameraEnhance,
  ActionHistory,
  ActionSpellcheck,
  SocialNotificationsOff,
  SocialPersonAdd,
  SocialShare,
  SocialGroupAdd,
  SocialGroup,
  SocialNotificationsNone,
  SocialMoodBad,
  SocialPlusOne,
  SocialMood,
  SocialPersonOutline,
  SocialPoll,
  SocialLocationCity,
  SocialPerson,
  SocialPeopleOutline,
  SocialCake,
  SocialWhatshot,
  SocialNotificationsPaused,
  SocialPublic,
  SocialPages,
  SocialPeople,
  SocialNotifications,
  SocialNotificationsActive,
  SocialSchool,
  SocialDomain,
  SocialPartyMode,
  AvNotInterested,
  AvPauseCircleOutline,
  AvNewReleases,
  AvMic,
  AvSkipPrevious,
  AvReplay5,
  AvMovie,
  AvForward10,
  AvGames,
  AvHighQuality,
  AvExplicit,
  AvHd,
  AvAlbum,
  AvRepeatOne,
  AvSkipNext,
  AvLibraryBooks,
  AvVolumeMute,
  AvLibraryMusic,
  AvPlayArrow,
  AvRadio,
  AvFastRewind,
  AvReplay,
  AvHearing,
  AvPause,
  AvEqualizer,
  AvVolumeUp,
  AvFastForward,
  AvSurroundSound,
  AvForward30,
  AvQueueMusic,
  AvReplay30,
  AvSortByAlpha,
  AvSubtitles,
  AvClosedCaption,
  AvVideoLibrary,
  AvWeb,
  AvMicNone,
  AvShuffle,
  AvStop,
  AvPlayCircleOutline,
  AvVideocamOff,
  AvQueue,
  AvVolumeDown,
  AvVideocam,
  AvRepeat,
  AvRecentActors,
  AvForward5,
  AvLoop,
  AvLibraryAdd,
  AvPlayCircleFilled,
  AvPlaylistAdd,
  AvMicOff,
  AvReplay10,
  AvAvTimer,
  AvVolumeOff,
  AvPauseCircleFilled,
  AvAirplay,
  AvSnooze,
  ImageBrush,
  ImageLooksOne,
  ImageDetails,
  ImageTimer3,
  ImageFilterNone,
  ImageLooks3,
  ImageFilter9,
  ImageFilter,
  ImageAssistantPhoto,
  ImageWbCloudy,
  ImageBrightness1,
  ImagePanoramaWideAngle,
  ImagePanoramaFishEye,
  ImagePortrait,
  ImageBrightness5,
  ImageExposureZero,
  ImageExposureNeg2,
  ImageWbAuto,
  ImageHdrOff,
  ImageNaturePeople,
  ImageAudiotrack,
  ImageCropPortrait,
  ImageColorize,
  ImageCompare,
  ImageFilter2,
  ImageTagFaces,
  ImageBlurCircular,
  ImageLens,
  ImageTune,
  ImageViewComfy,
  ImageCameraRoll,
  ImageCenterFocusStrong,
  ImageFlashOff,
  ImageCollectionsBookmark,
  ImagePhotoSizeSelectActual,
  ImageImageAspectRatio,
  ImageFilterHdr,
  ImageRotateRight,
  ImageFilterTiltShift,
  ImageCropFree,
  ImageStyle,
  ImageNature,
  ImagePhotoSizeSelectLarge,
  ImageAdjust,
  ImageFlare,
  ImageWbIridescent,
  ImageFilterDrama,
  ImageBrightness7,
  ImageBlurOn,
  ImageTimer10,
  ImageFlashOn,
  ImagePhotoLibrary,
  ImageBlurLinear,
  ImageCamera,
  ImageTimelapse,
  ImageLoupe,
  ImageExposurePlus1,
  ImageExposurePlus2,
  ImageFlashAuto,
  ImagePalette,
  ImageCropDin,
  ImageCrop169,
  ImageSlideshow,
  ImageFilter1,
  ImageCrop75,
  ImageMusicNote,
  ImageCropLandscape,
  ImageCrop32,
  ImageTimer,
  ImageWbIncandescent,
  ImageLooks5,
  ImageGradient,
  ImageViewCompact,
  ImageCenterFocusWeak,
  ImageLooks,
  ImageCollections,
  ImageMonochromePhotos,
  ImageBlurOff,
  ImagePhotoSizeSelectSmall,
  ImageFilter6,
  ImageCameraRear,
  ImageRotateLeft,
  ImageFilter7,
  ImageEdit,
  ImageFilter9Plus,
  ImageLeakRemove,
  ImageTexture,
  ImageBrightness6,
  ImageCropOriginal,
  ImageNavigateNext,
  ImageFilterCenterFocus,
  ImageAssistant,
  ImageFlip,
  ImageCropSquare,
  ImageVignette,
  ImageExposure,
  ImagePanoramaHorizontal,
  ImagePanorama,
  ImageCrop,
  ImageControlPoint,
  ImageRotate90DegreesCcw,
  ImageFilterBAndW,
  ImageGridOff,
  ImageBrightness3,
  ImageFilter8,
  ImageLeakAdd,
  ImageRemoveRedEye,
  ImagePhotoCamera,
  ImageStraighten,
  ImageFilter4,
  ImageGridOn,
  ImageFilter3,
  ImageLandscape,
  ImageFilterFrames,
  ImageIso,
  ImageTonality,
  ImageDehaze,
  ImageHdrStrong,
  ImageHealing,
  ImageHdrWeak,
  ImageFilterVintage,
  ImageFilter5,
  ImageImage,
  ImageColorLens,
  ImageLooks4,
  ImagePanoramaVertical,
  ImageBrightness4,
  ImageLooks6,
  ImageControlPointDuplicate,
  ImageCrop54,
  ImageHdrOn,
  ImagePhotoAlbum,
  ImageNavigateBefore,
  ImageSwitchVideo,
  ImageWbSunny,
  ImageAddToPhotos,
  ImagePhoto,
  ImageBrokenImage,
  ImagePictureAsPdf,
  ImageTransform,
  ImageCameraAlt,
  ImageBrightness2,
  ImageMovieCreation,
  ImageGrain,
  ImageLooksTwo,
  ImageTimerOff,
  ImageExposureNeg1,
  ImageCameraFront,
  ImageSwitchCamera,
  ContentForward,
  ContentSelectAll,
  ContentDrafts,
  ContentContentCopy,
  ContentFlag,
  ContentTextFormat,
  ContentReplyAll,
  ContentReply,
  ContentRemoveCircle,
  ContentAddCircle,
  ContentLink,
  ContentMail,
  ContentArchive,
  ContentSave,
  ContentRemove,
  ContentFontDownload,
  ContentRemoveCircleOutline,
  ContentCreate,
  ContentClear,
  ContentContentCut,
  ContentRedo,
  ContentMarkunread,
  ContentContentPaste,
  ContentBackspace,
  ContentReport,
  ContentSort,
  ContentInbox,
  ContentGesture,
  ContentBlock,
  ContentAdd,
  ContentUndo,
  ContentAddBox,
  ContentAddCircleOutline,
  ContentFilterList,
  ContentSend,
  NotificationSyncProblem,
  NotificationAirlineSeatIndividualSuite,
  NotificationVpnLock,
  NotificationAirlineSeatLegroomExtra,
  NotificationWifi,
  NotificationTapAndPlay,
  NotificationAirlineSeatFlatAngled,
  NotificationWc,
  NotificationSms,
  NotificationBluetoothAudio,
  NotificationFolderSpecial,
  NotificationSimCardAlert,
  NotificationEventNote,
  NotificationPersonalVideo,
  NotificationLiveTv,
  NotificationTimeToLeave,
  NotificationAdb,
  NotificationConfirmationNumber,
  NotificationAirlineSeatFlat,
  NotificationSync,
  NotificationVoiceChat,
  NotificationPhoneLocked,
  NotificationPhoneForwarded,
  NotificationSystemUpdate,
  NotificationMore,
  NotificationMms,
  NotificationPhoneInTalk,
  NotificationAirlineSeatReclineExtra,
  NotificationPhoneBluetoothSpeaker,
  NotificationAirlineSeatLegroomNormal,
  NotificationDoNotDisturbAlt,
  NotificationOndemandVideo,
  NotificationEventBusy,
  NotificationDoNotDisturb,
  NotificationDriveEta,
  NotificationAirlineSeatLegroomReduced,
  NotificationSyncDisabled,
  NotificationPhoneMissed,
  NotificationEventAvailable,
  NotificationAirlineSeatReclineNormal,
  NotificationVibration,
  NotificationPower,
  NotificationSdCard,
  NotificationPhonePaused,
  NotificationDiscFull,
  NotificationSmsFailed,
  NotificationNetworkLocked,
  HardwarePowerInput,
  HardwareWatch,
  HardwareGamepad,
  HardwareLaptop,
  HardwareKeyboardBackspace,
  HardwareSmartphone,
  HardwarePhonelinkOff,
  HardwarePhoneAndroid,
  HardwareMouse,
  HardwareLaptopChromebook,
  HardwareSecurity,
  HardwareTv,
  HardwareSpeakerGroup,
  HardwareKeyboardArrowUp,
  HardwareSimCard,
  HardwareCastConnected,
  HardwareMemory,
  HardwareDesktopMac,
  HardwareDesktopWindows,
  HardwareSpeaker,
  HardwareToys,
  HardwareKeyboardHide,
  HardwareRouter,
  HardwareTabletAndroid,
  HardwareHeadset,
  HardwareLaptopWindows,
  HardwareKeyboardArrowLeft,
  HardwareLaptopMac,
  HardwareTabletMac,
  HardwareKeyboardArrowRight,
  HardwareKeyboard,
  HardwarePhoneIphone,
  HardwareDeveloperBoard,
  HardwareDeviceHub,
  HardwareKeyboardReturn,
  HardwareHeadsetMic,
  HardwareTablet,
  HardwarePhonelink,
  HardwareKeyboardTab,
  HardwareComputer,
  HardwareCast,
  HardwareKeyboardArrowDown,
  HardwareDock,
  HardwareKeyboardVoice,
  HardwareScanner,
  HardwareKeyboardCapslock,
  AlertWarning,
  AlertErrorOutline,
  AlertAddAlert,
  AlertError,
  DeviceNetworkWifi,
  DeviceSignalWifi0Bar,
  DeviceSignalCellular4Bar,
  DeviceAccessAlarm,
  DeviceWallpaper,
  DeviceDataUsage,
  DeviceSignalCellularConnectedNoInternet1Bar,
  DeviceBatteryCharging80,
  DeviceLocationSearching,
  DeviceSignalCellular0Bar,
  DeviceSettingsSystemDaydream,
  DeviceBatteryChargingFull,
  DeviceScreenLockLandscape,
  DeviceBluetoothConnected,
  DeviceSdStorage,
  DeviceWidgets,
  DeviceBrightnessHigh,
  DeviceWifiLock,
  DeviceBatteryCharging60,
  DeviceBrightnessAuto,
  DeviceBattery60,
  DeviceBatteryCharging20,
  DeviceSignalCellular3Bar,
  DeviceSignalCellular2Bar,
  DeviceBatteryCharging50,
  DeviceBattery50,
  DeviceWifiTethering,
  DeviceBattery20,
  DeviceSignalCellularConnectedNoInternet2Bar,
  DeviceAccessAlarms,
  DeviceSignalWifi1Bar,
  DeviceScreenLockPortrait,
  DeviceAccessTime,
  DeviceBattery80,
  DeviceGpsOff,
  DeviceScreenLockRotation,
  DeviceBatteryUnknown,
  DeviceGpsNotFixed,
  DeviceSignalWifi3BarLock,
  DeviceNfc,
  DeviceDvr,
  DeviceSignalCellular1Bar,
  DeviceAirplanemodeActive,
  DeviceBattery90,
  DeviceBluetoothSearching,
  DeviceStorage,
  DeviceSignalCellularNoSim,
  DeviceBrightnessMedium,
  DeviceLocationDisabled,
  DeviceSignalWifi2BarLock,
  DeviceSignalWifiOff,
  DeviceBatteryFull,
  DeviceBluetooth,
  DeviceSignalCellularConnectedNoInternet3Bar,
  DeviceSignalWifi1BarLock,
  DeviceSignalCellularNull,
  DeviceBrightnessLow,
  DeviceBatteryCharging90,
  DeviceSignalWifi3Bar,
  DeviceSignalCellularOff,
  DeviceSignalCellularConnectedNoInternet0Bar,
  DeviceBluetoothDisabled,
  DeviceDevices,
  DeviceAddAlarm,
  DeviceGraphicEq,
  DeviceBatteryAlert,
  DeviceSignalWifi4BarLock,
  DeviceSignalWifi4Bar,
  DeviceSignalCellularConnectedNoInternet4Bar,
  DeviceDeveloperMode,
  DeviceGpsFixed,
  DeviceBatteryStd,
  DeviceBattery30,
  DeviceAirplanemodeInactive,
  DeviceSignalWifi2Bar,
  DeviceNetworkCell,
  DeviceUsb,
  DeviceBatteryCharging30,
  DeviceScreenRotation
};



// WEBPACK FOOTER //
// ./src/js/components/Material/SvgIcons.js